import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { CampaignAttributionService } from '../services/campaign-attribution.service';

/**
 * CLP-1259: a campaign link that asks for "Offerte anfragen"
 * (`/docu-hub?product=…`) must end on DocuHub, also when the client was not
 * logged in yet.
 *
 * Logged out, `authGuard` sends the link to /login → /auth, and every way out
 * of the auth flow (password, passkey, registration, 2FA setup, login page)
 * navigates to /dashboard. Sitting on /dashboard, this guard redirects to
 * /docu-hub while a deep-link product is pending; DocuHub then consumes it and
 * opens the modal. Without a pending product the dashboard opens as usual.
 */
export const pendingDeepLinkGuard: CanActivateFn = () => {
  const attribution = inject(CampaignAttributionService);
  return attribution.hasPendingOfferProduct()
    ? inject(Router).createUrlTree(['/docu-hub'])
    : true;
};
